import React from 'react';
import axios from 'axios';
import string from 'yup/lib/string';
import object from 'yup/lib/object';
import { isEmpty } from 'lodash';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import CompetitionAnswers from './competition-answers';
import {
    getComponentVisibility, addCompletedFormToAddressBookLocalStorage, getVerificationEndpoint, getUserAddressBooks, verifyUserInAddressBook, getUserDetailsFromCookie
} from '../helpers/toch-helpers';
import userService from '../../../../general/js/user/user-service';
import { TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME } from '../../../../general/js/user/constants';

class CompetitionQuestionLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSubmitAttempted: false,
            isDataSent: false,
            fieldsErrors: {},
            answer: null,
            formHasErrors: false,
            addressBooks: null
        };

        this.schema = object().shape({
            answer: string().required('Please choose an option').nullable(),
        });
    }

    componentDidMount() {
        this.checkCompetitionStatus();
    }

    checkCompetitionStatus() {
        const { verificationEndpoint, question } = this.props.options;
        const userAddressBooks = getUserAddressBooks();

        if (!isEmpty(verificationEndpoint) && userAddressBooks === null) this.handleComponentVisibilityApiCall();

        const userInAddressBook = verifyUserInAddressBook(userAddressBooks, question.dotmailerAddressBook.addressBookID);

        if (userInAddressBook) {
            this.setState({ isDataSent: true });
        }
    }

    handleComponentVisibilityApiCall() {
        const endpoint = getVerificationEndpoint(this.props.options);

        axios.post(endpoint).then((response) => {
            if (response.data !== null && response.data !== undefined && response.data !== '') {
                userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(response.data));
                this.setState({ addressBooks: response.data });
            }
        }).catch(() => {
            this.setState({ competitionsList: null });
        });
    }

    validate() {
        const { answer } = this.state;
        return this.schema.validate({ answer }, { abortEarly: false }).then(() => {
            this.setState({ fieldsErrors: {} });
            return true;
        }, (error) => {
            const fieldsErrors = {};
            error.inner.forEach((fieldError) => {
                fieldsErrors[fieldError.path] = fieldError.errors;
            });

            this.setState({ fieldsErrors });
            return false;
        });
    }

    onSubmit = (e) => {
        e.preventDefault();

        const { question } = this.props.options;
        const updatedUserAddressBooks = addCompletedFormToAddressBookLocalStorage(question.dotmailerAddressBook.addressBookID, question.dotmailerAddressBook.adressBookName);
        const userDetails = getUserDetailsFromCookie();

        if (!this.state.isDataSent) {
            this.setState({ isSubmitAttempted: true });
            this.validate().then((isValid) => {
                if (isValid) {
                    if (question.dotmailerAddressBook !== undefined) {
                        const data = {
                            emailAddress: userDetails.email,
                            firstName: userDetails.firstName,
                            lastName: userDetails.lastName,
                            addressBookId: question.dotmailerAddressBook.addressBookID,
                            addressBookName: question.dotmailerAddressBook.adressBookName,
                            dotmailerColumn: question.dotmailerColumn,
                            answer: this.state.answer
                        };

                        axios.post(this.props.options.endpoint, data).then(() => {
                            userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(updatedUserAddressBooks));
                            this.setState({ isDataSent: true, addressBooks: updatedUserAddressBooks });
                        }).catch((error) => {
                            this.setState({ formHasErrors: true });
                            console.error(error);
                        });
                    } else {
                        this.setState({ formHasErrors: true });
                        console.error('dotmailerAddressBook is not configured');
                    }
                }
            });
        }
    }

    onAnswerChange = (value) => {
        this.setState({ answer: value });
    }

    render() {
        const {
            answers,
            question,
            componentVisibility,
            isMastercardComponent,
            background,
            mastercardLogo,
            mastercardText,
            competitionCompletedMessage,
            competitionHasErrorsMessage,
        } = this.props.options;
        const {
            answer, isDataSent, formHasErrors, addressBooks
        } = this.state;
        const isVisible = getComponentVisibility(componentVisibility);
        const isMastercard = isMastercardComponent.toLowerCase() === 'true';
        const isInAddressBooks = addressBooks !== null ? verifyUserInAddressBook(JSON.stringify(addressBooks), question.dotmailerAddressBook.addressBookID) : null;
        const disable = isInAddressBooks !== null ? isInAddressBooks : isDataSent;

        return (
            isVisible &&
            <div className="competition-survey__wrap">
                <div className="competition-survey__media">
                    <div className="competition-survey__media--wrapper">
                        <SitecoreImageField img={background} className='competition-survey__media--backgroundImage' />
                    </div>
                </div>
                <div className="competition-survey__content">
                    <div className="competition-survey__head">
                        {
                            isMastercard &&
                            <div className='mastercard-branding'>
                                <div className='mastercard-branding--title'>{mastercardText}</div>
                                <SitecoreImageField img={mastercardLogo} className='mastercard-branding--logo' />
                            </div>
                        }
                        <div className="competition-survey__tag" dangerouslySetInnerHTML={{ __html: question.description }}></div>
                    </div>
                    <div className="competition-survey__heading">
                        <h2 className="competition-survey__title">{question.question}</h2>
                    </div>
                    <form className="competition-survey__form" onSubmit={this.onSubmit}>
                        <div className={`toch-survey ${disable ? 'is-disabled' : ''}`}>
                            <div className="toch-survey__wrap">
                                <div className="toch-survey__title">
                                </div>
                                <div className="toch-survey__content">
                                    <CompetitionAnswers
                                        answers={answers}
                                        value={answer}
                                        onChange={this.onAnswerChange} />
                                </div>
                            </div>
                        </div>
                        {
                            !disable &&
                            <div className="toch-survey__submit-button">
                                {
                                    formHasErrors &&
                                    <div>{competitionHasErrorsMessage}</div>
                                }
                                <button
                                    type="submit"
                                    className="button button--super"
                                >
                                    <span className="button-content button-content--icon">
                                        <span>{question.submitButtonText}</span>
                                        <svg
                                            className="icon button__arrow-right"
                                            width="14" height="12"
                                            focusable="false">
                                            <use xlinkHref="#icon-arrow-right">
                                            </use>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        }
                        {
                            disable &&
                            <div className="toch-survey__submit-button">
                                <SitecoreLinkField className="button button--primary" link={question.ctaLink} />
                                <div className="toch-survey__message">{competitionCompletedMessage}</div>
                            </div>
                        }
                        <SitecoreLinkField className="toch-survey__tc-link" link={question.termsAndConditions} />
                    </form>
                    {
                        isMastercard &&
                        <div className='mastercard-branding to-bottom'>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default CompetitionQuestionLayout;
